// extracted by mini-css-extract-plugin
export default {"content":"ModernSheet_content__TfsE1"};